module.exports = __webpack_public_path__ + "Flama-Bold.woff?a122bce8b423bc468e94b8c2f5ad1918";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Flama-Bold.woff
// module id = 906
// module chunks = 0